module.exports = __webpack_public_path__ + "fa-solid-900.svg?dc9fdd51ed87ad29a28e97089b39f7c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.svg
// module id = 35
// module chunks = 0